export const links = [
    {
        id:1,
        name:'_Home',
        url:'#home'
    },
    {
        id:2,
        name:'_Proyectos',
        url:'#projects'
    },
    {
        id:3,
        name:'_Contacto',
        url:'#contact'
    },

];

